import SelectDinamico from "../../SelectDinamico";
import ConsultaCentroCusto from "../../../../lib/json/consultas/CentroCustoSelect.json"
import { RetornaUsuarioLogado } from "../../../contents/VariaveisGlobais";

function SelectCentroCusto({campoCentroCusto, changeCentroCusto, queryCentroCusto, disabled = false, empresaLogada, returnOriginal = false, loadDefault = true, label="Centro de Custo", bindItem, field, filtraFilial=false, isMultiplo=false, filtraUserCC=true }){
    const empresaFilial = empresaLogada || localStorage.getItem('empresaFilial')
    const usuarioLogado = RetornaUsuarioLogado(filtraFilial, empresaFilial);
    const parametroEmpresa = usuarioLogado.filtraParametroEmpresasCentroCusto

    let cConsultaDefault = ConsultaCentroCusto.consulta + " WHERE CTT.D_E_L_E_T_ <> '*' AND CTT_CLASSE = 2 AND CTT_BLOQ = 2 "
    let filtraCentroCusto = ''

    if (parametroEmpresa.centroCusto.length > 0 && filtraUserCC ){
        filtraCentroCusto += " AND CTT_CUSTO IN ('" + parametroEmpresa.centroCusto.join("','") + "')"
    }
    
    if (filtraFilial){
        cConsultaDefault += " AND CTT_FILIAL = FILIAL(CTT) "
    }

    const consulta = queryCentroCusto || ( loadDefault ? cConsultaDefault + filtraCentroCusto : '' )
    const centroCustoValue = bindItem ? bindItem[field] : campoCentroCusto;
    
    return (
        <SelectDinamico
            label={label}
            cText="CTT_CUSTO + ' - ' + item.CTT_DESC01"
            cValue="CTT_CUSTO"
            campoValue={centroCustoValue}
            consulta={consulta}
            tabela={ConsultaCentroCusto.tabelas}
            isMultiplo={isMultiplo}
            EmpresaLogada={empresaFilial}
            onchange={(e) => changeCentroCusto(e)}
            showNoFilter={false}
            selectOptionUnique={true}
            returnOrigem={returnOriginal}
            bindItem={bindItem}
            field={field}
            disabled={disabled}
        />
    )
}

export default SelectCentroCusto;